
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-partner-werden",
      function () {
        return require("private-next-pages/affiliate-partner-werden.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-partner-werden"])
      });
    }
  